import { __decorate } from "tslib";
import { Vue, Watch, Prop } from "vue-property-decorator";
import Component from "vue-class-component";
import "../plugins/vuetify";
// import Canvas from "./Canvas.vue";
import Frontali from "./Frontali.vue";
import ColoriFrontali from "./ColoriFrontali.vue";
import Aste from "./Aste.vue";
import Clip from "./Clip.vue";
import Nome from "./PersonalName.vue";
import LentiSole from "./LentiSole.vue";
import User from "./User.vue";
// import Checksum from "./Checksum";
import LanguageCard from "./LanguageCard.vue";
import LanguageButton from "./buttons/LanguageButton.vue";
import ShowCartButton from "./buttons/ShowCartButton.vue";
import FavoriteButton from "./buttons/FavoriteButton.vue";
import HistoryButton from "./buttons/HistoryButton.vue";
import PrintButton from "./buttons/PrintButton.vue";
import ShareButton from "./buttons/ShareButton.vue";
import StoreLocatorButton from "./buttons/StoreLocatorButton.vue";
import StoreLocator from "./StoreLocator.vue";
import config from "@/config/custom-config";
import _ from "lodash";
let Configurator = class Configurator extends Vue {
  constructor() {
    super(...arguments);
    // Add prop darkTheme
    this.darkTheme = false;
    this.isMenuOpen = false;
    this.goToFavs = false;
    this.e1 = 1;
    this.collapse = false;
    this.menuFullscreen = false;
    this.frontali = {
      title: this.$t("message.frontali"),
      active: false,
      settingItem: null
    };
    this.colori = {
      title: this.$t("message.colori"),
      active: false,
      settingItem: null
    };
    this.aste = {
      id: 2,
      title: this.$t("message.Aste"),
      active: false,
      settingItem: null
    };
    this.nome = {
      title: this.$t("message.Nome"),
      active: false,
      image: require("../assets/nomePersonalizzato.png")
    };
    this.miniNav = true;
    this.cartUpdated = false;
    this.cartUpdatedNotify = "";
    this.showCantAddToCart = false;
    this.openLanguageSelection = false;
    this.rowNotesDialog = false;
    this.addToCartDialog = false;
    this.stepperChange = [];
    this.notes = "";
    this.storeLocatorDialog = false;
    this.countryCode = "";
  }
  async mounted() {
    this.$store.commit("configurator/setLensesType", "V", {
      root: true
    });
    // this.$store.dispatch("configurator/frontali/setColor", this.defaultFrontColor);
    // this.$store.dispatch(
    //     "configurator/aste/setColor", this.defaultTemplesColor
    //   );
    // if (this.windowsWidth < 768) {
    //   this.activeMenu = "message.frontali";
    // }
    // let canvas = this.$refs.canvas;
    // @ts-ignore
    this.cc = await this.$rest.getCountryCode();
    if (this.userIsGuest) {
      this.countryCode = this.cc.data;
      this.$i18n.locale = this.cc.data;
    } else {
      this.countryCode = this.user.country;
      this.$i18n.locale = this.user.country;
    }
    // If the user is from usa, redirect to usa configurator
    // if (this.usa_country.indexOf(this.countryCode) != -1) {
    //   window.location.href =
    //     "https://usa-igreen-configurator.thema-optical.com";
    // }
    // this.langSelected = this.cc.data;
    this.ensureValidCurrentStep();
  }
  resetSettingItem() {
    this.frontali.settingItem = null;
    this.colori.settingItem = null;
    this.aste.settingItem = null;
  }
  resetConfiguration() {
    this.$store.commit("configurator/setTemplesMaterial", "PL");
    if (this.defaultFrontColor) this.$store.dispatch("configurator/frontali/setColor", this.defaultFrontColor);else this.$store.commit("configurator/setColore", null);
    if (this.defaultTemplesColor) this.$store.dispatch("configurator/aste/setColor", this.defaultTemplesColor);else this.$store.commit("configurator/setTemplesColor", null);
    this.$store.commit("configurator/setFinishing", "S");
    this.$store.commit("configurator/setTemplesFinishing", "S");
  }
  openBottomTab() {
    if (this.collapse == true) {
      this.collapse = false;
    }
  }
  onDownArrowClick() {
    // split -> canvas full
    if (!this.collapse && !this.menuFullscreen) {
      this.collapse = true;
      this.menuFullscreen = false;
      return;
    }
    // menu full -> split
    if (this.menuFullscreen) {
      this.menuFullscreen = false;
      this.collapse = false;
    }
  }
  onUpArrowClick() {
    // split -> menu full
    if (!this.collapse && !this.menuFullscreen) {
      this.menuFullscreen = true;
      this.collapse = false;
      return;
    }
    // canvas full -> split
    if (this.collapse) {
      this.collapse = false;
      this.menuFullscreen = false;
    }
  }
  onStepClick(step) {
    if (!this.isStepVisible(step)) return;
    this.openBottomTab();
    this.e1 = step;
  }
  hasVisibleStepAfter(step) {
    return [1, 2, 3, 4, 5, 6].some(candidate => {
      return candidate > step && this.isStepVisible(candidate);
    });
  }
  isStepVisible(step) {
    if (step === 1) return this.showStepFrontali;
    if (step === 2) return this.showStepColori;
    if (step === 3) return this.showStepAste;
    if (step === 4) return this.showStepNome;
    if (step === 5) return this.showStepClip;
    if (step === 6) return this.showStepLenti;
    return false;
  }
  ensureValidCurrentStep() {
    if (this.isStepVisible(this.e1)) return;
    const firstVisible = [1, 2, 3, 4, 5, 6].find(step => this.isStepVisible(step));
    this.e1 = firstVisible || 1;
  }
  /**
   * If the user has selected sight glasses but no lenses, ask
   * whether he wants to add some lenses
   * Otherwise proceed with the addToCart procedure
   */
  startAddToCart() {
    this.addToCartDialog = true;
  }
  closeAlertQrcode() {
    this.activeModelFromQrCode = true;
  }
  openFirstPage() {
    this.$emit("open-first-page");
  }
  /**
   * Programmatically move to the sight lenses selection stepper
   */
  goToLenses() {
    // Close dialog and move user to lenses
    this.showDoYouWantLenses = false;
    // @ts-ignore
    this.$refs.addToCart.$el.scrollIntoView(true, {
      behavior: "smooth"
    });
    this.openBottomTab();
    this.e1 = 6;
  }
  addToCart(openCart) {
    this.addToCartDialog = false;
    this.rowNotesDialog = false;
    this.$store.dispatch("configurator/cart/addToCart");
    if (openCart) {
      this.currentTab = "tab-cart";
      this.profileOpen = true;
    }
  }
  get activeModelFromQrCode() {
    return this.$store.state.configurator.activeModelFromQrCode;
  }
  set activeModelFromQrCode(v) {
    this.$store.state.configurator.activeModelFromQrCode = v;
  }
  get frontalModelQrCode() {
    return this.$store.state.configurator.frontalQrCode;
  }
  get frontalColorQrCode() {
    return this.$store.state.configurator.colorQrCode;
  }
  get logoImage() {
    if (this.config.logoByUser) {
      if (this.userIsGuest) {
        return this.config.logoImage;
      }
      return this.userClientLogo || "";
    }
    return this.config.logoImage;
  }
  get userClientLogo() {
    var _this$$store$state$co;
    return ((_this$$store$state$co = this.$store.state.configurator.user) === null || _this$$store$state$co === void 0 ? void 0 : _this$$store$state$co.clientLogo) || null;
  }
  get frontalTemplesColorQrCode() {
    return this.$store.state.configurator.templeQrCode;
  }
  get activeModelText() {
    let phrase = "";
    if (!this.frontalModelQrCode) {
      phrase = this.$t("message.il_modello_non_è_piu_disponibile").toString();
    }
    if (!this.frontalColorQrCode) {
      phrase = this.$t("message.il_colore_non_è_più_disponibile").toString();
    }
    if (!this.frontalTemplesColorQrCode) {
      phrase = this.$t("message.le_aste_non_sono_più_disponibili").toString();
    }
    return phrase;
  }
  get marchio() {
    return this.$store.state.marchio;
  }
  get btActive() {
    return this.$store.state.btActive;
  }
  get showStepFrontali() {
    return this.config.menu_frontali;
  }
  get showStepColori() {
    return this.config.menu_colori;
  }
  get showStepAste() {
    return !this.btActive && this.config.menu_aste;
  }
  get showStepNome() {
    return !this.btActive && this.config.menu_nome && this.hasPersonalizationOptions;
  }
  get showStepClip() {
    return this.glassType == "V" && this.config.menu_clip;
  }
  get hasPersonalizationOptions() {
    const hasCiliare = this.config.nome_ciliare;
    const hasTemplePersonalization = this.config.personalizzazioniAste && (this.config.nome_extdx || this.config.nome_extsx || this.config.nome_intdx || this.config.nome_intsx);
    return hasCiliare || hasTemplePersonalization;
  }
  get showStepLenti() {
    return this.glassType == "S" && this.config.menu_lenti;
  }
  get user() {
    return this.$store.state.configurator.user.user;
  }
  get userIsGuest() {
    return this.$store.getters["configurator/user/isGuest"];
  }
  get cartRows() {
    return this.$store.state.configurator.cart.cartRows;
  }
  get checkoutSuccess() {
    return this.$store.state.configurator.cart.checkoutSuccess;
  }
  get config() {
    return config;
  }
  get defaultFrontModel() {
    return this.config.defaultFrontModel || "";
  }
  get defaultFrontColor() {
    return this.config.frontali_default_color_enabled !== false ? this.config.defaultFrontColor || "" : "";
  }
  get defaultTemplesColor() {
    return this.config.aste_default_color_enabled !== false ? this.config.defaultTemplesColor || "" : "";
  }
  async onDefaultFrontColorEnabledChanged(enabled, previous) {
    if (enabled === false) {
      this.$store.commit("configurator/setColore", null);
    } else if (previous !== undefined && this.defaultFrontColor) {
      await this.$store.dispatch("configurator/frontali/setColor", this.defaultFrontColor);
    }
  }
  async onDefaultTemplesColorEnabledChanged(enabled, previous) {
    if (enabled === false) {
      this.$store.commit("configurator/setTemplesColor", null);
    } else if (previous !== undefined && this.defaultTemplesColor) {
      await this.$store.dispatch("configurator/aste/setColor", this.defaultTemplesColor);
    }
  }
  get profileOpen() {
    return this.$store.state.profileOpen;
  }
  set profileOpen(newValue) {
    this.$store.commit("setProfileOpen", newValue);
  }
  get currentTab() {
    return this.$store.state.currentTab;
  }
  set currentTab(newValue) {
    this.$store.commit("setCurrentTab", newValue);
  }
  get configurations() {
    return this.$store.state.configurations;
  }
  get haveConfigurations() {
    var _this$$store$state$co2;
    return ((_this$$store$state$co2 = this.$store.state.configurations) === null || _this$$store$state$co2 === void 0 ? void 0 : _this$$store$state$co2.length) > 0;
  }
  get canAddToCart() {
    return !this.userIsGuest && this.configurationComplete;
  }
  get configurationComplete() {
    const fromStore = Boolean(this.$store.getters["configurator/configurationComplete"]);
    if (fromStore) return true;
    return this.configurationCompleteWithLogoFallback;
  }
  get configurationCompleteWithLogoFallback() {
    var _s$aste, _s$aste2, _s$aste3, _s$aste4, _s$aste5, _s$aste6, _s$aste7, _s$aste8, _s$frontali, _s$frontali2, _s$frontali3, _s$frontali4, _s$frontali5, _s$frontali6, _s$frontale, _s$frontale2;
    const s = this.$store.state.configurator;
    const a = s.frontale && s.calibro !== "" && s.naso !== "" && s.colore && s.finitura && s.coloreAste;
    const hasLogoPlaceholder = value => {
      const text = String(value || "").trim();
      return text === "[LOGO]" || /^https?:\/\//i.test(text);
    };
    const isEngravingOk = (name, color) => {
      const text = String(name || "").trim();
      if (!text) return true;
      if (hasLogoPlaceholder(text)) return true;
      return color != null;
    };
    const engravingsOk = isEngravingOk((_s$aste = s.aste) === null || _s$aste === void 0 ? void 0 : _s$aste.extDxName, (_s$aste2 = s.aste) === null || _s$aste2 === void 0 ? void 0 : _s$aste2.extDxNameColor) && isEngravingOk((_s$aste3 = s.aste) === null || _s$aste3 === void 0 ? void 0 : _s$aste3.extSxName, (_s$aste4 = s.aste) === null || _s$aste4 === void 0 ? void 0 : _s$aste4.extSxNameColor) && isEngravingOk((_s$aste5 = s.aste) === null || _s$aste5 === void 0 ? void 0 : _s$aste5.intDxName, (_s$aste6 = s.aste) === null || _s$aste6 === void 0 ? void 0 : _s$aste6.intDxNameColor) && isEngravingOk((_s$aste7 = s.aste) === null || _s$aste7 === void 0 ? void 0 : _s$aste7.intSxName, (_s$aste8 = s.aste) === null || _s$aste8 === void 0 ? void 0 : _s$aste8.intSxNameColor) && isEngravingOk((_s$frontali = s.frontali) === null || _s$frontali === void 0 ? void 0 : _s$frontali.name, (_s$frontali2 = s.frontali) === null || _s$frontali2 === void 0 ? void 0 : _s$frontali2.nameColor) && isEngravingOk((_s$frontali3 = s.frontali) === null || _s$frontali3 === void 0 ? void 0 : _s$frontali3.cilDxNome, (_s$frontali4 = s.frontali) === null || _s$frontali4 === void 0 ? void 0 : _s$frontali4.cilDxColore) && isEngravingOk((_s$frontali5 = s.frontali) === null || _s$frontali5 === void 0 ? void 0 : _s$frontali5.cilSxNome, (_s$frontali6 = s.frontali) === null || _s$frontali6 === void 0 ? void 0 : _s$frontali6.cilSxColore);
    const clipsOk = !s.clip || !s.numberOfClips || s.numberOfClips === s.lentiSoleClip.length;
    const lensOk = ((_s$frontale = s.frontale) === null || _s$frontale === void 0 ? void 0 : _s$frontale.U_TIPO_VSP) === "S" ? s.lenteSole != null : ((_s$frontale2 = s.frontale) === null || _s$frontale2 === void 0 ? void 0 : _s$frontale2.U_TIPO_VSP) === "V";
    return Boolean(a && engravingsOk && clipsOk && lensOk);
  }
  get isConfigurationSaved() {
    return this.$store.state.configurator.isConfigurationSaved;
  }
  get colore() {
    return this.$store.state.configurator.colore;
  }
  get glassType() {
    return this.$store.state.configurator.glassType;
  }
  get themeColor() {
    return this.darkTheme ? "grey darken-2" : "grey lighten-2";
  }
  get currentSubline() {
    var _this$$store$state$co3;
    return (_this$$store$state$co3 = this.$store.state.configurator.frontale) === null || _this$$store$state$co3 === void 0 ? void 0 : _this$$store$state$co3.U_THE_SOTTOLINEA;
  }
  get cartTotal() {
    return this.cartRows.length;
  }
  get canShowCart() {
    if (!this.userIsGuest && this.cartTotal && this.cartTotal > 0) {
      if (_.indexOf(["EN", "GB", "IE"], this.user.country) >= 0 && this.user.username != "C0000023311") {
        return false;
      } else {
        return true;
      }
    }
    return false;
  }
  get note() {
    return this.$store.state.configurator.note;
  }
  set note(newVal) {
    this.$store.commit("configurator/setRowNotes", newVal);
  }
  get frontModel() {
    var _this$$store$state$co4;
    return (_this$$store$state$co4 = this.$store.state.configurator.frontale) === null || _this$$store$state$co4 === void 0 || (_this$$store$state$co4 = _this$$store$state$co4.U_THE_MODELLO) === null || _this$$store$state$co4 === void 0 ? void 0 : _this$$store$state$co4.replace(/([0-9]+)(S)/i, "$1");
  }
  get frontSize() {
    return this.$store.getters["configurator/frontSize"];
  }
  get frontColor() {
    return this.$store.getters["configurator/frontColor"];
  }
  get templesColor() {
    return this.$store.getters["configurator/templesColor"];
  }
  get showDoYouWantLenses() {
    return this.$store.state.showDoYouWantLenses;
  }
  set showDoYouWantLenses(newVal) {
    this.$store.commit("setShowDoYouWantLenses", newVal);
  }
  get ConfigurationProgress() {
    let progress = 0;
    if (this.frontModel) {
      progress += 25;
    }
    if (this.frontSize) {
      progress += 25;
    }
    if (this.frontColor) {
      progress += 25;
    }
    if (this.templesColor) {
      progress += 25;
    }
    return progress;
  }
  get validateFrontali() {
    return this.frontModel && !_.isEmpty(this.frontSize);
  }
  get validateColori() {
    return !_.isEmpty(this.frontColor);
  }
  get validateAste() {
    return !_.isEmpty(this.templesColor);
  }
  get validateNome() {
    return !_.isEmpty(this.$store.state.configurator.frontali.name);
  }
  get validateClip() {
    var _state$lentiSoleClip;
    const state = this.$store.state.configurator;
    if (!this.showStepClip) return true;
    if (!state.clip || !state.numberOfClips) return true;
    return state.numberOfClips === (((_state$lentiSoleClip = state.lentiSoleClip) === null || _state$lentiSoleClip === void 0 ? void 0 : _state$lentiSoleClip.length) || 0);
  }
  get validateLenti() {
    if (this.glassType == "S") {
      return !_.isEmpty(this.$store.state.configurator.lenteSole);
    }
    return true;
  }
  get getFavIcon() {
    if (this.isConfigurationSaved != -1) {
      return "favorite";
    } else {
      return "favorite_border";
    }
  }
  async changedUser(nVal) {
    if (nVal) {
      this.countryCode = this.$store.state.configurator.user.user.country;
      // this.langSelected = nVal.country;
      this.$i18n.locale = this.$store.state.configurator.user.user.country;
    } else if (nVal == null) {
      this.countryCode = this.cc.data;
      this.$i18n.locale = this.cc.data;
      // this.langSelected = this.cc.data;
    }
  }
  onMiniNavChange() {
    this.frontali.active = false;
    this.colori.active = false;
    this.aste.active = false;
  }
  onCartTotalChange(newVal, oldVal) {
    if (oldVal < newVal) {
      /*delta = newVal - oldVal
              this.cartUpdatedNotify = delta +' '+ this.$t('message.elemento_aggiunto_al_carrello')+'!'*/
      this.cartUpdated = true;
    }
  }
  onE1Change(newVal, oldVal) {
    this.stepperChange = [oldVal, newVal];
  }
  onStepVisibilityChanged() {
    this.ensureValidCurrentStep();
  }
};
__decorate([Prop()], Configurator.prototype, "darkTheme", void 0);
__decorate([Watch("config.frontali_default_color_enabled", {
  immediate: true
})], Configurator.prototype, "onDefaultFrontColorEnabledChanged", null);
__decorate([Watch("config.aste_default_color_enabled", {
  immediate: true
})], Configurator.prototype, "onDefaultTemplesColorEnabledChanged", null);
__decorate([Watch("user")], Configurator.prototype, "changedUser", null);
__decorate([Watch("miniNav")], Configurator.prototype, "onMiniNavChange", null);
__decorate([Watch("cartTotal")], Configurator.prototype, "onCartTotalChange", null);
__decorate([Watch("e1")], Configurator.prototype, "onE1Change", null);
__decorate([Watch("btActive"), Watch("glassType"), Watch("showStepFrontali"), Watch("showStepColori"), Watch("showStepAste"), Watch("showStepNome"), Watch("showStepClip"), Watch("showStepLenti")], Configurator.prototype, "onStepVisibilityChanged", null);
Configurator = __decorate([Component({
  components: {
    Frontali,
    ColoriFrontali,
    Aste,
    Clip,
    Nome,
    LentiSole,
    User,
    LanguageCard,
    LanguageButton,
    ShowCartButton,
    FavoriteButton,
    HistoryButton,
    PrintButton,
    ShareButton,
    StoreLocatorButton,
    StoreLocator,
    config
  }
})], Configurator);
export default Configurator;